import { Chip } from '@mui/material';
import type { MouseEventHandler } from 'react';
import classSet from 'react-classset';
import { Link } from 'react-router-dom';

import VNLiveStatusBadge from '@/components/VNLiveStatusBadge/VNLiveStatusBadge';
import itemUtils from '@/utils/itemUtils';

import { Permission } from '../../enums';
import type { Item } from '../../models';
import type { Permissions } from '../../models/Permissions';

export interface Iprops {
  item: Item;
  permissions: Permissions;
  onClick?: MouseEventHandler<any>;
  href?: string;
}

const FuelAssetTitle = ({ item, permissions, onClick, href }: Iprops) => {
  const Component = href ? Link : 'div';
  const isBlocked = itemUtils.isNonEditableNestedChannelAsset(item);

  return (
    <Component
      className={classSet({
        clickable: !item.isGlobalFillerChannel && !isBlocked && permissions?.has(Permission.EditAsset),
        'no-clickable': item.isGlobalFillerChannel || isBlocked || !permissions?.has(Permission.EditAsset),
        'fuel-table-row--expired': item.item ? item.item.isExpired : false,
        'fuel-table-row--embargoed': item.item ? item.item.isEmbargoed : false,
        embargoed: item ? item.isEmbargoed : false,
        expired: item ? item.isExpired : false,
      })}
      title={item.title}
      onClick={(event) => {
        if (isBlocked) return;
        if (onClick) onClick(event);
      }}
      to={href}
    >
      <div className="text-ellipses title">{item.title}</div>
      <div className="status-section">
        {item.specialStatus === 'Live' ? (
          <VNLiveStatusBadge />
        ) : item.specialStatus ? (
          <Chip title={item.specialStatus} label={item.specialStatus} size="small" color="success" />
        ) : null}
        {item.hasMigratedFromAppsToChannel && <Chip title="powr" label="powr" size="small" color="info" />}
      </div>
    </Component>
  );
};

export default FuelAssetTitle;
